import { Nillable } from '@web/utils';
import { InPostPointLocation } from './in-post-point-location';

export class InPostPointSelect {
  public constructor(
    private readonly data: {
      name?: Nillable<string>;
      address?: Nillable<{
        city: string;
        province: string;
        postCode: string;
        street: string;
        buildingNumber?: Nillable<string>;
        flatNumber?: Nillable<string>;
      }>;
      location?: Nillable<InPostPointLocation>;
      description?: Nillable<string>;
    },
  ) {}

  public get name(): Nillable<string> {
    return this.data.name;
  }

  public get city(): Nillable<string> {
    return this.data.address?.city;
  }

  public get province(): Nillable<string> {
    return this.data.address?.province;
  }

  public get postCode(): Nillable<string> {
    return this.data.address?.postCode;
  }

  public get street(): Nillable<string> {
    return this.data.address?.street;
  }

  public get buildingNumber(): Nillable<string> {
    return this.data.address?.buildingNumber;
  }

  public get flatNumber(): Nillable<string> {
    return this.data.address?.flatNumber;
  }

  public get location(): Nillable<InPostPointLocation> {
    return this.data.location;
  }

  public get description(): Nillable<string> {
    return this.data.description;
  }
}
